import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
} from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { AccordionArrowPurple, AccordionArrowPurpleClose } from 'Images';
import { useState } from 'react';
import { ApplyAccordionSummary } from './ApplyAccordionSummary';
import { IApplication } from 'API/applies/applies';
import { DetailsBody } from './DetailsBody';
import { APPLY_TYPES, STATUS_TYPES } from 'Enum/Applies';

interface IApplicationAccordion {
  apply: IApplication;
  expanded?: boolean;
}

export const ApplicationAccordion = ({
  apply,
  expanded,
}: IApplicationAccordion) => {
  const [isExpanded, setIsExpanded] = useState(expanded || false);
  const isDesktop = useIsDesktop();

  const hideAccordionDetails =
    apply.type === APPLY_TYPES.online ||
    (apply.type === APPLY_TYPES.telephone &&
      apply.status.status === STATUS_TYPES.INFORMATION_WAS_PROVIDED);

  return (
    <Accordion
      expanded={isExpanded}
      onChange={(e, expanded) => setIsExpanded(expanded)}
      disableGutters
      elevation={0}
      sx={{
        bgcolor: 'transparent',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary
        sx={{
          padding: isDesktop ? '32px 24px' : '16px 24px 16px 16px',
          bgcolor: '#fff',
          border: '1px solid',
          borderColor: 'primary.shade_100',
          borderRadius: !hideAccordionDetails
            ? isExpanded
              ? '16px 16px 0 0'
              : '16px'
            : '16px',
          gap: isDesktop ? '0' : '22px',
          flexDirection: isDesktop ? 'row' : 'column',
          '.MuiAccordionSummary-content': {
            margin: 0,
            cursor: hideAccordionDetails ? 'default' : 'pointer',
          },
        }}
        expandIcon={
          !hideAccordionDetails ? (
            <>
              {isExpanded && (
                <Avatar
                  src={AccordionArrowPurpleClose}
                  alt={''}
                  sx={{
                    width: '35px',
                    height: '35px',
                    rotate: '180deg',
                  }}
                />
              )}
              {!isExpanded && (
                <Avatar
                  src={AccordionArrowPurple}
                  alt={''}
                  sx={{
                    width: '40px',
                    height: '40px',
                  }}
                />
              )}
            </>
          ) : (
            <></>
          )
        }
      >
        <ApplyAccordionSummary
          subject={apply.subject}
          subSubject={apply.subSubject}
          type={apply.type}
          applyNumber={apply.shemeshApplyNumber}
          status={apply.status.status}
          statusUpdateDate={apply.status.statusDate}
          statusDescription={apply.status.description}
          linkPrefixText={apply.link?.linkPrefixText}
          linkSuffixText={apply.link?.linkSuffixText}
          linkText={apply.link?.linkText}
          linkUrl={apply.link?.linkUrl}
          isAdminIsrId={!!apply.adminIsrId}
        />
      </AccordionSummary>
      {!hideAccordionDetails && (
        <AccordionDetails
          sx={{
            bgcolor: '#fff',
            border: '1px solid',
            borderColor: 'primary.shade_100',
            borderRadius: '0 0 16px 16px',
            marginTop: '3px',
            padding: 0,
          }}
        >
          <DetailsBody application={apply} />
        </AccordionDetails>
      )}
    </Accordion>
  );
};
